module.exports = __webpack_public_path__ + "img/avatar2.904eba2e.jpg";